module.exports = __webpack_public_path__ + "img/128.2.cb15833c.png";